// extracted by mini-css-extract-plugin
export default {"container":"TaskInformation_container__9CZVW","avatar":"TaskInformation_avatar__9+zgl","textDescription":"TaskInformation_textDescription__KhSW9"};